import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { ApproveInspectionCtrl }       from './inspection.approve';
import { InspectionCtrl }              from './inspection';
import { InspectionItemCtrl }          from './inspection.item';
import { InspectionItemDirective }     from './inspection.item.directive';

import { INSPECTIONKEYS }              from './inspection.keys.constant';
import { INSPECTIONKEYSAU }            from './inspection.keys-au.constant';
import { INSPECTIONKEYSUS }            from './inspection.keys-us.constant';

import { InspectionListCtrl }      from './inspection.list';
import { InspectionsBoxCtrl }      from './inspection.box';
import { InspectionsBoxDirective } from './inspection.box.directive';
import { InspectionService }       from './inspection.service';
import { InspectionSettingsCtrl }  from './inspection.settings';
import { InspectionStatusFilter }  from './inspection.status.filter.ajs';
import { InspectionStatusPipe }    from './inspection.status.pipe';
import { InspectionsStates }       from './inspections.states.ajs';

import '../../app-lite/inspections/inspections.module.ajs';

angular.module('workshop.inspections', [
  'app-lite.inspections'
])
.config(InspectionsStates)
.constant('INSPECTIONKEYS', INSPECTIONKEYS)
.constant('INSPECTIONKEYSAU', INSPECTIONKEYSAU)
.constant('INSPECTIONKEYSUS', INSPECTIONKEYSUS)
.controller('ApproveInspectionCtrl', ApproveInspectionCtrl)
.controller('InspectionCtrl', InspectionCtrl)
.controller('InspectionItemCtrl', InspectionItemCtrl)
.controller('InspectionListCtrl', InspectionListCtrl)
.controller('InspectionsBoxCtrl', InspectionsBoxCtrl)
.controller('InspectionSettingsCtrl', InspectionSettingsCtrl)
.directive('inspectionItem', InspectionItemDirective)
.directive('inspectionsBox', InspectionsBoxDirective)
.factory('Inspection', InspectionService)
.filter('inspectionStatus', InspectionStatusFilter)
.service('inspectionStatusPipe',downgradeInjectable(InspectionStatusPipe));